import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ea625122"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "innerPage",
  class: "dashboard"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "viewPortSize",
  class: "d-none d-sm-inline"
}, null, -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "row mr-0 ml-0" }
const _hoisted_5 = { class: "col-xl-3 col-sm-6 pb-2" }
const _hoisted_6 = { class: "d-flex" }
const _hoisted_7 = {
  class: "text-heavy-green dashboard__label -select-label",
  for: "mortgage_type_selector"
}
const _hoisted_8 = { class: "col-xl-3 col-sm-6 pb-2" }
const _hoisted_9 = { class: "d-flex" }
const _hoisted_10 = {
  class: "text-heavy-green dashboard__label -select-label",
  for: "mortgage_product_selector"
}
const _hoisted_11 = { class: "itext-dropdown__list" }
const _hoisted_12 = { class: "col-xl-3 col-sm-6 pb-2" }
const _hoisted_13 = { class: "d-flex" }
const _hoisted_14 = { class: "text-heavy-green dashboard__label -select-label" }
const _hoisted_15 = { class: "flex-tab-extra-checkbox-first" }
const _hoisted_16 = ["checked"]
const _hoisted_17 = {
  slot: "label-slot",
  for: "huisbankkorting_check"
}
const _hoisted_18 = { class: "col-xl-3 col-sm-6 pb-2" }
const _hoisted_19 = { class: "d-flex" }
const _hoisted_20 = {
  class: "text-heavy-green dashboard__label -select-label",
  for: "duurzaamheidskorting_selector"
}
const _hoisted_21 = {
  id: "col8Div",
  class: "px-0 mt-1"
}
const _hoisted_22 = { class: "spl-sm-1" }
const _hoisted_23 = { class: "text-heavy-green dashboard__label -label-date" }
const _hoisted_24 = {
  id: "explanationText",
  class: "dashboard__subtitle text-justify"
}
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = {
  key: 1,
  class: "bring-forward spl-sm-1 d-flex"
}
const _hoisted_28 = {
  key: 0,
  class: "dashboard__bridgingloans"
}
const _hoisted_29 = ["id"]
const _hoisted_30 = {
  key: 2,
  class: "bring-forward spl-sm-1"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "mt-0 mb-1" }, null, -1))
const _hoisted_32 = { class: "text-muted text-justify" }
const _hoisted_33 = { class: "dashboard__spinner-container" }
const _hoisted_34 = {
  key: 1,
  class: "em-shadow-tile bg-white px-1 py-2 row m-0"
}
const _hoisted_35 = { class: "d-flex flex-column justify-content-center w-100" }
const _hoisted_36 = { class: "text-center" }
const _hoisted_37 = { class: "text-center" }

import type { BridgingLoan, Period, PeriodLegacy } from '@shared/models';
import { computed, reactive } from 'vue';
import { firstLetterToUppercase, getSanitizedUrlParameters, removeCookieConsent } from './utils/DashboardHelper';
import { formatPercentage, getFixedPeriodInYears, isLegacyFormatApi } from '@/utils';
import { HeaderLabels, HeaderLabelsLegacy, MortgageProduct, SustainabilityDiscount } from '@/constants';
import { Locale, translate } from '@/i18n';
import { MortgageTypeIrt, PayoutType, RiskCategories, RiskCategoriesLegacy, RiskCategoryType, RiskCategoryTypeLegacy, SustainableRiskCategory } from '@shared/constants';
import DropDown from '@/components/DropDown/DropDown.vue';
import { EXTENDED_MORTGAGE_TYPES_KEYS } from '@/views/Dashboard/constants';
import { getInterestRates } from '@/services/InterestRatesService/InterestRatesService';
import InterestRatesTable from '@/components/InterestRatesTable/InterestRatesTable.vue';
import IText from '@/components/IText/IText.vue';
import type { RatesParams } from '@/models';
import ScAnalyticsApi from '@aab/sc-analytics-api';
import { useI18nStore } from '@/stores/i18n';
import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'Dashboard',
  setup(__props) {

const { annuities, linear, interestFree, equity, sustainable, credit } = MortgageTypeIrt;

const DEFAULT_MORTGAGE_TYPES_KEYS = [annuities, linear, interestFree, equity, sustainable];
const SHOWN_INTEREST_PERIODS = [0, 5, 10, 15, 20, 25, 30];

const extendedMortgageTypes = computed((): any => {
  return [...EXTENDED_MORTGAGE_TYPES_KEYS].map((value) => ({ name: translate(`label:${value.toLowerCase()}`), value }));
});

const defaultMortgageTypes = computed((): any => {
  return [...DEFAULT_MORTGAGE_TYPES_KEYS, 'more-types'].map((value) => ({ name: translate(`label:${value.toLowerCase()}`), value }));
});

const mortgageValidityPeriods = computed((): any => {
  return [
    { name: translate('label:budgetLabel'), value: MortgageProduct.budget },
    { name: translate('label:woningLabel'), value: MortgageProduct.house }
  ];
});

const duurzaamheidskortingTypes = computed((): any => {
  return [
    { name: translate('label:noDuurzaamheidskorting'), value: SustainabilityDiscount.NoDiscount },
    { name: translate('label:duurzaamheidskortingA'), value: SustainabilityDiscount.A_OR_HIGHER },
    { name: translate('label:duurzaamheidskortingB'), value: SustainabilityDiscount.B }
  ];
});
const state = reactive({
  defaultMortgageTypes: defaultMortgageTypes,
  extendedMortgageTypes: extendedMortgageTypes,
  mortgageType: annuities,
  mortgageValidityPeriods: mortgageValidityPeriods,
  mortgageProduct: MortgageProduct.budget,
  duurzaamheidskortingTypes: duurzaamheidskortingTypes,
  duurzaamheidskortingType: SustainabilityDiscount.NoDiscount,
  headerLabels: [] as ReadonlyArray<string>,
  huisbankkorting: false,
  duurzaamheidskorting: undefined as any,
  defaultMortgageType: '' as MortgageTypeIrt | string,

  // interest table
  periods: [] as ReadonlyArray<Period | PeriodLegacy>,
  riskCategories: [...RiskCategories.DEFAULT] as ReadonlyArray<RiskCategoryType | RiskCategoryTypeLegacy | PayoutType | SustainableRiskCategory>,

  // generic
  isLoading: true,
  isError: false,

  overbruggingskrediet: '',
  // deeplink
  overbruggingskredieten: [] as ReadonlyArray<BridgingLoan>,
  isLegacyFormatApi: false
});

ScAnalyticsApi.pageTrack({
  eventName: 'interest rates table page visit',
  widgetModule: 'interest rates table vue.js',
  widgetName: `interest-rates-${translate('segment')}`,
  widgetState: 'view',
  widgetTitle: 'Interest Rates Table Widget'
});

removeCookieConsent();
initializeServiceInputs(getSanitizedUrlParameters(useRouter().currentRoute.value.query));
getInterestRateCategories(state.mortgageType);
getRates(state.mortgageProduct, state.mortgageType, state.huisbankkorting, state.duurzaamheidskorting);

function initializeServiceInputs(ratesParamsObj: RatesParams): void {
  if (ratesParamsObj) {
    // from deeplink
    state.mortgageProduct = ratesParamsObj.mortgageProduct;
    state.mortgageType = ratesParamsObj.mortgageType;
    state.defaultMortgageType = ratesParamsObj.mortgageType;
    state.huisbankkorting = ratesParamsObj.huisbankkorting;
    state.duurzaamheidskorting = ratesParamsObj.duurzaamheidskorting;
    state.duurzaamheidskortingType = state.duurzaamheidskorting ? SustainabilityDiscount.A_OR_HIGHER : SustainabilityDiscount.NoDiscount;

    if (state.mortgageType === sustainable) {
      state.huisbankkorting = true;
      state.duurzaamheidskorting = false;
      state.duurzaamheidskortingType = SustainabilityDiscount.NoDiscount;
    }
  } else {
    state.mortgageProduct = MortgageProduct.budget;
    state.mortgageType = annuities;
    state.defaultMortgageType = '';
    state.huisbankkorting = true;
    state.duurzaamheidskorting = false;
    state.duurzaamheidskortingType = SustainabilityDiscount.NoDiscount;
  }
}

function getDate(date: Date, locale: Locale): string | Date {
  const options: Intl.DateTimeFormatOptions = {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  };
  return firstLetterToUppercase(date.toLocaleString(locale, options));
}

function sortOverbruggingskredieten(overbruggingskredieten: ReadonlyArray<BridgingLoan>): ReadonlyArray<BridgingLoan> {
  if (overbruggingskredieten === undefined || overbruggingskredieten.length === 0) return [];

  const overbruggingskredietenSortable = overbruggingskredieten.toSorted();
  // eslint-disable-next-line functional/immutable-data
  return overbruggingskredietenSortable.sort((a, b) => b.duration - a.duration);
}

function getRates(mortgageProduct: MortgageProduct, mortgageType: MortgageTypeIrt, huisbankkorting: boolean, duurzaamheidskorting: boolean): void {
  state.isLoading = true;
  getInterestRates(mortgageProduct, mortgageType, huisbankkorting, duurzaamheidskorting, state.duurzaamheidskortingType)
    .then(({ data }) => {
      state.isLegacyFormatApi = isLegacyFormatApi(data);
      getInterestRateCategories(state.mortgageType);
      state.periods = curateInterestTableInputs(state.mortgageType, data.periods);
      state.overbruggingskredieten = sortOverbruggingskredieten(data.overbruggingskredieten ?? []);
    })
    .catch(() => {
      state.isError = true;
    })
    .finally(() => {
      state.isLoading = false;
    });
}

function selectMortgageType(event: CustomEvent): void {
  const value: MortgageTypeIrt = event.detail.value;
  if (state.mortgageType === value) return;

  state.mortgageType = value;
  ScAnalyticsApi.eventTrack({
    eventName: 'click',
    eventCategory: 'mortgage type selection',
    eventAction: `irt: mortgage type selected: ${value}`
  });

  if (state.mortgageType !== sustainable) {
    getRates(state.mortgageProduct, state.mortgageType, state.huisbankkorting, state.duurzaamheidskorting);
  } else {
    getRates(state.mortgageProduct, state.mortgageType, state.huisbankkorting, false);
  }
}

function selectMortgageProduct(event: CustomEvent): void {
  const value: MortgageProduct = event.detail.value;

  if (state.mortgageProduct === value) return;
  state.mortgageProduct = value;
  ScAnalyticsApi.eventTrack({
    eventName: 'click',
    eventCategory: 'mortgage product selection',
    eventAction: `irt: mortgage product selected: ${value}`
  });
  getRates(state.mortgageProduct, state.mortgageType, state.huisbankkorting, state.duurzaamheidskorting);
}

function selectHuisbankorting(): void {
  state.huisbankkorting = !state.huisbankkorting;

  ScAnalyticsApi.eventTrack({
    eventName: 'click',
    eventCategory: 'mortgage discounts',
    eventAction: `irt: huisbankorting set to ${state.huisbankkorting}`
  });

  getRates(state.mortgageProduct, state.mortgageType, state.huisbankkorting, state.duurzaamheidskorting);
}

function selectDuurzaamheidskorting(event: CustomEvent): void {
  const value: SustainabilityDiscount = event.detail.value;
  state.duurzaamheidskorting = !(value === SustainabilityDiscount.NoDiscount);
  state.duurzaamheidskortingType = value;

  ScAnalyticsApi.eventTrack({
    eventName: 'click',
    eventCategory: 'mortgage discounts',
    eventAction: `irt: duurzaamheidskorting set to ${state.duurzaamheidskorting}`,
    eventLabel: state.duurzaamheidskortingType
  });
  getRates(state.mortgageProduct, state.mortgageType, state.huisbankkorting, state.duurzaamheidskorting);
}

function curateInterestTableInputs(mortgageType: MortgageTypeIrt, periods: ReadonlyArray<Period | PeriodLegacy>): ReadonlyArray<Period | PeriodLegacy> {
  if (mortgageType === equity || mortgageType === sustainable) {
    periods.forEach((interestPeriod) => {
      // TODO (S.Panfilov) any (rate is PeriodRate, but here we have a param reassign)
      interestPeriod.rates.forEach((rate: any) => {
        // TODO (S.Panfilov) eslint disabled
        // eslint-disable-next-line functional/immutable-data, no-param-reassign
        rate.ltv = mortgageType === equity ? rate.payout : SustainableRiskCategory.Rent;
      });
    });
  }

  return periods;
}

function getInterestRateCategories(mortgageType: MortgageTypeIrt): void {
  const labels: Record<string, ReadonlyArray<string>> = state.isLegacyFormatApi ? HeaderLabelsLegacy : HeaderLabels;
  const categories: Record<string, ReadonlyArray<RiskCategoryType | RiskCategoryTypeLegacy | PayoutType | SustainableRiskCategory>> = state.isLegacyFormatApi ? RiskCategoriesLegacy : RiskCategories;
  state.headerLabels = (labels[mortgageType] ? labels[mortgageType] : labels.DEFAULT).map((label: string) => translate(label));
  state.riskCategories = categories[mortgageType] ? categories[mortgageType] : categories.DEFAULT;
}

function displayOverbruggingskrediet(): boolean {
  return [equity, credit].indexOf(state.mortgageType) < 0;
}

function getHuisbankkortingLabel(isCheckbox: boolean): string {
  return isCheckbox ? translate('label:huisbankkorting') : translate('text:huisbankkorting');
}

function getOverbruggingskredietPeriod(krediet: BridgingLoan): string {
  return krediet.duration === 1 ? `(${translate('text:variable')})` : `(${getFixedPeriodInYears(krediet)} ${translate('text:year')})`;
}

return (_ctx: any,_cache: any) => {
  const _component_aab_link = _resolveComponent("aab-link")!
  const _component_aab_select = _resolveComponent("aab-select")!
  const _component_aab_checkbox = _resolveComponent("aab-checkbox")!
  const _component_aab_spinner = _resolveComponent("aab-spinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (!state.isError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('label:mortgageTypeSelectorTop')), 1)
              ]),
              _createVNode(DropDown, {
                id: 'mortgage_type_selector',
                label: _ctx.$t('label:mortgageTypeSelectorTop'),
                "default-option": state.mortgageType,
                options: state.defaultMortgageTypes,
                "extended-options": state.extendedMortgageTypes,
                onSelectionChanged: selectMortgageType
              }, null, 8, ["label", "default-option", "options", "extended-options"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('label:mortgageProduct')), 1),
                _createVNode(IText, {
                  class: "itext-dropdown ml-1",
                  name: 'mortgage type'
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, _toDisplayString(_ctx.$t('iText:mortgageProduct')), 1),
                    _createElementVNode("ul", _hoisted_11, [
                      _createElementVNode("li", null, _toDisplayString(_ctx.$t('iText:differenceOne')), 1),
                      _createElementVNode("li", null, _toDisplayString(_ctx.$t('iText:differenceTwo')), 1),
                      _createElementVNode("li", null, _toDisplayString(_ctx.$t('iText:differenceThree')), 1),
                      _createElementVNode("li", null, _toDisplayString(_ctx.$t('iText:differenceFour')), 1),
                      _createElementVNode("li", null, [
                        _createTextVNode(_toDisplayString(_ctx.$t('iText:differenceFive')) + " ", 1),
                        _createVNode(_component_aab_link, {
                          target: "_blank",
                          url: _ctx.$t('linkUrl:mortgageProduct'),
                          rel: "noopener noreferrer"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('linkText:here')), 1)
                          ]),
                          _: 1
                        }, 8, ["url"]),
                        _createTextVNode(" . ")
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_aab_select, {
                id: "mortgage_product_selector",
                class: "dashboard__select",
                "aab-select-items": JSON.stringify(state.mortgageValidityPeriods),
                "aab-select-value": state.mortgageProduct,
                onAabSelectValueChange: selectMortgageProduct
              }, null, 8, ["aab-select-items", "aab-select-value"])
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('label:discount')), 1),
                _createVNode(IText, {
                  class: "itext-dropdown ml-1",
                  name: 'huisbankkorting'
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('iText:huisbankkorting')), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_aab_checkbox, null, {
                  default: _withCtx(() => [
                    _createElementVNode("input", {
                      id: "huisbankkorting_check",
                      slot: "input-slot",
                      type: "checkbox",
                      class: "dashboard__checkbox",
                      checked: state.huisbankkorting,
                      onChange: selectHuisbankorting
                    }, null, 40, _hoisted_16),
                    _createElementVNode("label", _hoisted_17, _toDisplayString(getHuisbankkortingLabel(true)), 1)
                  ]),
                  _: 1
                })
              ])
            ], 512), [
              [_vShow, state.mortgageType !== _unref(MortgageTypeIrt).credit]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t('label:duurzaamheidskorting')), 1),
                _createVNode(IText, {
                  class: "itext-dropdown ml-1",
                  name: 'duurzaamheidskorting'
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, _toDisplayString(_ctx.$t('iText:duurzaamheidskorting')), 1),
                    _createVNode(_component_aab_link, {
                      target: "_blank",
                      url: _ctx.$t('linkUrl:duurzaamheidskorting'),
                      rel: "noopener noreferrer",
                      type: "single"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('linkText:duurzaamheidskorting')), 1)
                      ]),
                      _: 1
                    }, 8, ["url"])
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_aab_select, {
                id: "duurzaamheidskorting_selector",
                class: "dashboard__select",
                "aab-select-items": JSON.stringify(state.duurzaamheidskortingTypes),
                "aab-select-value": state.duurzaamheidskortingType,
                onAabSelectValueChange: selectDuurzaamheidskorting
              }, null, 8, ["aab-select-items", "aab-select-value"])
            ], 512), [
              [_vShow, state.mortgageType !== _unref(MortgageTypeIrt).sustainable && state.mortgageType !== _unref(MortgageTypeIrt).credit]
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("label", _hoisted_23, _toDisplayString(getDate(new Date(), _ctx.$t('portal'))), 1),
              _createElementVNode("small", _hoisted_24, [
                _createTextVNode(_toDisplayString(_ctx.$t('text:rates') + _ctx.$t('text:' + state.mortgageType) + _ctx.$t('text:' + state.mortgageProduct) + _ctx.$t('text:mortgage')) + " ", 1),
                (state.mortgageType !== _unref(MortgageTypeIrt).credit)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString((state.huisbankkorting ? _ctx.$t('text:with') : _ctx.$t('text:without')) + getHuisbankkortingLabel(false)), 1))
                  : _createCommentVNode("", true),
                (state.mortgageType !== _unref(MortgageTypeIrt).sustainable && state.mortgageType !== _unref(MortgageTypeIrt).credit)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_26, ", " + _toDisplayString((state.duurzaamheidskorting ? _ctx.$t('text:with') : _ctx.$t('text:without')) + _ctx.$t('text:duurzaamheidskorting')), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            (!state.isLoading && !state.isError)
              ? (_openBlock(), _createBlock(InterestRatesTable, {
                  key: 0,
                  "interest-periods": state.periods,
                  "shown-interest-periods": SHOWN_INTEREST_PERIODS,
                  "header-labels": state.headerLabels,
                  "used-rate-categories": state.riskCategories
                }, null, 8, ["interest-periods", "header-labels", "used-rate-categories"]))
              : _createCommentVNode("", true),
            (!state.isLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  (displayOverbruggingskrediet())
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.overbruggingskredieten, (krediet) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: krediet.duration,
                            class: "dashboard__bridgingloan"
                          }, [
                            _createElementVNode("label", {
                              id: `bridgingLoan${krediet.duration}`,
                              class: "text-heavy-green dashboard__label -credit"
                            }, [
                              _createTextVNode(_toDisplayString(_ctx.$t('label:overbruggingskrediet')) + " ", 1),
                              _createElementVNode("span", null, _toDisplayString(getOverbruggingskredietPeriod(krediet)), 1)
                            ], 8, _hoisted_29),
                            _createElementVNode("span", null, _toDisplayString(_unref(formatPercentage)(krediet.rate, _unref(useI18nStore)().locale)), 1)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (!state.isLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                  _hoisted_31,
                  _createElementVNode("small", _hoisted_32, _toDisplayString(_ctx.$t('text:disclaimer')), 1)
                ]))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("div", _hoisted_33, [
              _createVNode(_component_aab_spinner, {
                class: "dashboard__spinner",
                size: "10"
              })
            ], 512), [
              [_vShow, state.isLoading]
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (state.isError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("h2", _hoisted_36, _toDisplayString(_ctx.$t('title:error')), 1),
            _createElementVNode("h3", _hoisted_37, _toDisplayString(_ctx.$t('text:error')), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})